import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./PdfImportButton.css";
import PreviewPopup from "../../UILibrary/FilePreviewPopup/PreviewPopup";
import Overlay from "../../UILibrary/Overlay";
import DragAndDropComponent from "../../UILibrary/DragAndDrop";
import { uploadRfpPdf, analyzeRfpById } from "../../../store/rfpSlice";

const PdfImportButton = ({
  recSuppliers,
  setRecommendedSuppliers,
  setImportCompleted,
  setRecommendedSuppliersLoaded,
  management,
}) => {
  const dispatch = useDispatch();
  const { importCompleted, loading, error } = useSelector((state) => state.rfp);
  const [showPopup, setShowPopup] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [importedFiles, setImportedFiles] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [missingFileError, setMissingFileError] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
    setImportedFiles([]);
  };

  const cancelImport = () => {
    togglePopup();
  };

  const handleUpload = async () => {
    if (!pdfFile) {
      setMissingFileError(true);
      return;
    }

    setMissingFileError(false); // clear error if file is present

    const file = pdfFile;
    const resultAction = await dispatch(uploadRfpPdf(file));

    if (uploadRfpPdf.fulfilled.match(resultAction)) {
      completeImport();
      const fileId = resultAction.payload.fileId;
      dispatch(analyzeRfpById(fileId));
    } else {
      console.error("Upload failed:", resultAction.payload);
    }
  };

  const completeImport = () => {
    togglePopup();
    setImportCompleted(true);
    handlePdf();
  };

  const handlePreview = (file) => {
    console.log(file);
    setShowPreviewPopup(true);
  };

  const closePreview = () => {
    setShowPreviewPopup(false);
  };
  const handlePdf = async () => {
    setTimeout(() => {
      const data = recSuppliers;
      if (data) {
        setRecommendedSuppliers(data);
        setRecommendedSuppliersLoaded(true);
        setImportCompleted(false);
      }
    }, 5000);
  };

  const handleDelete = (fileName) => {
    setImportedFiles((prevImportedFiles) =>
      prevImportedFiles.filter((file) => file.name !== fileName)
    );
  };

  const handleGroupSelection = (group) => {
    setSelectedGroups((prevSelectedGroups) =>
      prevSelectedGroups.includes(group)
        ? prevSelectedGroups.filter((g) => g !== group)
        : [...prevSelectedGroups, group]
    );
  };
  return (
    <div className="pdf-import-container">
      <button className="pdf-import-btn" onClick={togglePopup}>
        Upload RFP/RFQ
      </button>
      {showPopup && (
        <>
          <Overlay />
          <div className="popup-import-container">
            <div className="flex flex-col px-[51px] pb-[34px] w-[618px] max-h-[80vh] rounded-[8px] bg-white shadow-md mt-[60px] overflow-y-auto">
              <div className="flex flex-col justify-start items-start mb-4 mt-8">
                <p>Upload RFP/RFQ document</p>
                <p
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    color: "#7B7B7B",
                  }}
                >
                  Uploading this document will help narrow down your supplier
                  search
                </p>
              </div>
              <DragAndDropComponent
                onPreview={handlePreview}
                onDelete={handleDelete}
                importedFiles={importedFiles}
                setImportedFiles={setImportedFiles}
                setPdfFile={setPdfFile}
                setMissingFileError={setMissingFileError}
                error={error}
                rfp={true}
              />

              {(error || missingFileError) && (
                <p className="text-red-600 text-sm mt-2 text-left">
                  {missingFileError ? "Please select a file to upload." : error}
                </p>
              )}

              <div className="bottom-buttons">
                <button onClick={cancelImport} className="cancel-button">
                  Cancel
                </button>
                <button
                  onClick={handleUpload}
                  className="flex justify-center items-center rounded-[3.797px] w-[76.897px] h-[31.328px] px-[11.392px] py-[5.696px] outline-none border-none bg-[#EAF524] text-black"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {showPreviewPopup && (
        <>
          <Overlay />
          <PreviewPopup file={pdfFile} onClose={closePreview} />
        </>
      )}
    </div>
  );
};
export default PdfImportButton;
